import { NgModule } from '@angular/core';

import { NavbarRoutingModule } from './navbar-routing.module';
import { SideNavComponent } from './side-nav/side-nav.component';
import { UiCommonModule } from '@widgets/ui-common/ui.common.module';
import { TopNavComponent } from './top-nav/top-nav.component';
import { UserMenuComponent } from './top-nav/user-menu/user-menu.component';
import { SitePortalModule } from '@widgets/site-common/navbar/top-nav/site-portal/site-portal.module';
import { AuthModule } from '@services/auth/auth.module';
import { NgxPermissionsModule } from 'ngx-permissions';

@NgModule({
  declarations: [SideNavComponent, TopNavComponent, UserMenuComponent],
  exports: [SideNavComponent, TopNavComponent],
  imports: [NgxPermissionsModule.forChild(), UiCommonModule, NavbarRoutingModule, SitePortalModule, AuthModule]
})
export class NavbarModule {}
